import { render, staticRenderFns } from "./AliyunCaptchaGuard.vue?vue&type=template&id=54988f16&scoped=true"
import script from "./AliyunCaptchaGuard.vue?vue&type=script&lang=js"
export * from "./AliyunCaptchaGuard.vue?vue&type=script&lang=js"
import style0 from "./AliyunCaptchaGuard.vue?vue&type=style&index=0&id=54988f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54988f16",
  null
  
)

export default component.exports